import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate, useParams, useOutletContext } from 'react-router-dom';
import CreationFooter from "../components/CreationFooter";
import { useAlert } from 'react-alert'
import { updatePrice, PriceDisplay } from "../components/PriceDisplay";
import { parseSurveyJson } from "../../common_components/SurveyHelpers";
import { SurveyDetailCard, EmptySurveyDetailCard, NewSurveyDetailCard } from "../../missions_components/sub_page_components/SurveyOverviewCard";
import CreateMissionHeaderAndTitleRow from "../components/CreateMissionHeaderAndTitleRow";
import { ResearcherContext } from "../../../../ResearcherContext";

// Api Calls
import MissionPriceQuotesAPI from "../../../api/api_calls/MissionPriceQuotesAPI";
import SurveyAPI from "../../../api/api_calls/SurveyAPI";


function SurveyReview(props) {

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()
    const [submitInProcess, setSubmitInProcess] = useState(false);
    const [missionType, loadingMissionType, nextPage, backPage] = [props.missionType, props.loadingMissionType, props.nextPage, props.backPage]
    const { researcher, setResearcher, refreshResearcher } = useContext(ResearcherContext);


    const [loadingSurvey, setLoadingSurvey] = useState(true);
    const [surveyJson, setSurveyJson] = useState({});
    const [surveyQuestions, setSurveyQuestions] = useState([]);
    const [questionCount, setQuestionCount] = useState(-1);

    const [price, setPrice] = useState("-");
    const [totalPrice, setTotalPrice] = useState("-");

    function updatePriceWrapper() {
        updatePrice(setPrice, setTotalPrice, missionId, navigate, alert);
    }


    // const [sessionLength, setSessionLength] = useState(-1);
    // const [numberRespondents, setNumberRespondents] = useState(-1);
    // const [videoRequired, setVideoRequired] = useState(false);
    // const [colleagues, setColleagues] = useState("");

    // const sessionLengthTooltip = "The length of each feedback session."
    // const numberRespondentsTooltip = "The total number of sessions you'd like to have"
    // const videoRequiredTooltop = "Is the respondent required to turn on video for the session?"
    // const colleagesTooltip = "Colleagues that will also receive calendar invites for sessions. They will not automatically be invited to this platform. Type in their emails separated by commas."


    function onClickBack() {
        navigate(backPage, { state: { missionId: missionId } })
    }
    function onClickNext(event) {
        event.preventDefault();
        navigate(nextPage, { state: { missionId: missionId } })

    }

    useEffect(() => {
        async function getSurvey() {
            const response = await SurveyAPI.showSurvey({ missionId: missionId, handleRedirect: navigate });
            if (response.success) {
                if (response.survey_exists) {
                    setSurveyJson(response.survey_json);
                    setSurveyQuestions(parseSurveyJson(response.survey_json))
                    setQuestionCount(response.question_count);
                    setLoadingSurvey(false);
                } else {
                    setSurveyJson({});
                    setQuestionCount(0);
                    setLoadingSurvey(false);
                }
            } else {
                alert.show(response.error, { type: 'error' })
            }
        }

        // Set the path for the button if there's a direct link.
        getSurvey();
        updatePriceWrapper();
    }, [])

    return (
        <div className="create-mission-primary-content-container">
            <CreateMissionHeaderAndTitleRow title={"Survey"} subtitle="Create the survey you want your target audience to answer." price={price} totalPrice={totalPrice} />
            <div className="session-details-container" >
                <NewSurveyDetailCard loadingSurvey={loadingSurvey} questionCount={questionCount} surveyQuestions={surveyQuestions} isScreener={false} />
                <CreationFooter buttonText="Next" onClickBack={onClickBack} onClickSubmit={onClickNext} submitLoading={submitInProcess} />
            </div>
        </div>

    )
}


export default SurveyReview;